export default __webpack_public_path__ + "static/media/2wheelcar.4e996c21.png";